// Session HttpOnly et CSRF assurés par le transport existant lib/http.js.
export async function agentApi(path, method = 'GET', body) {
  const r = await fetch(`${process.env.REACT_APP_BACKEND_URL ?? ''}/api/export-agent${path}`, {
    method, ...(body === undefined ? {} : {headers: {'Content-Type':'application/json'}, body: JSON.stringify(body)}),
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(typeof data.detail === 'string' ? data.detail : `Erreur ${r.status} : vérifier les champs.`);
  return data;
}
